import { Component, Input } from '@angular/core';
import { NavigationService } from 'libs/portal/src/services/navigation/navigation.service';

@Component({
  selector: 'app-navbar-buttons',
  templateUrl: './navbar-buttons.component.html',
  styleUrls: ['./navbar-buttons.component.scss'],
})
export class NavbarButtonsComponent {
  @Input() buttons: any[] = [];
  constructor(private navigationService: NavigationService) {}

  nav(button: any) {
    this.navigationService.Navigate(button.routerLink);
  }
}
